import React, { useEffect } from "react";
import { useFilterContext } from "../../contexts/FilterContext";
import SelectFilter from "./SelectFilter";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

const ProgramsFilter = ({ programs }) => {
  const { name, filterValue, setFilterValue, updateURLParams } =
    useFilterContext();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const filterParam = searchParams.get(name);
  const { t } = useTranslation();
  const handleInputChange = (value) => {
    setFilterValue(value);
    updateURLParams(name, value);
  };
  useEffect(() => {
    !filterParam && handleInputChange(programs[0]?.id?.toString() ?? "");
    // eslint-disable-next-line
  }, [programs, filterParam]);
  return (
    <div style={{ position: "relative" }}>
      <label
        style={{
          fontWeight: "bold",
          position: "absolute",
          zIndex: 1,
          top: "-8px",
          left: "10px",
          backgroundColor: "white",
          fontSize: "12px",
          padding: "0 4px",
        }}
      >
        Programs
      </label>
      <SelectFilter
        options={programs?.map((program) => ({
          value: program.id.toString(),
          label: program.name,
        }))}
        placeholder={<div>{t("Program")}</div>}
        defaultValue={filterValue.toString()}
      />
    </div>
  );
};

export default ProgramsFilter;
